<template>
  <div class="container flex-col">
    <div class="fixed-header">
      <van-nav-bar left-text="返回" left-arrow @click-left="backToPreviousPage" title="我的消费" class="custom-nav-bar" />
      <div class="filter-section">
        <van-button size="small" type="primary" plain @click="showFilterPopup = true" class="filter-button">
          <van-icon name="filter" />
          <span>{{ getFilterSummary() }}</span>
        </van-button>
      </div>

      <van-popup v-model:show="showFilterPopup" position="bottom" round class="filter-popup">
        <div class="popup-header">
          <div class="popup-title">筛选条件</div>
          <van-button type="primary" size="small" @click="handleFilterConfirm" class="confirm-button">
            确定
          </van-button>
        </div>
        <div class="popup-content">
          <v-merchant-selector @merchant-selected="onMerchantSelected" class="selector-component" />
          <v-date-range-selector :selected-from="fromDate" :selected-to="toDate"
            @date-range-changed="onDateRangeChanged" class="selector-component" />
        </div>
      </van-popup>
    </div>
    <div class="scrollable flex-1">
      <div class="category-tags flex flex-wrap gap-2" v-if="statements.length > 0">
        <div v-for="category in allCategories" :key="category" class="category-tag"
          :class="{ 'category-tag-active': selectedCategory === category }" @click="selectCategory(category)">
          {{ category }}
        </div>
      </div>
      <div class="statement-list">
        <div v-show="showAccount(item.category)" v-for="(item, index) in statements" :key="index">
          <v-account-statement :statement="item" />
        </div>
        <div v-if="statements.length === 0" class="flex-col items-center justify-center p-16">
          <van-empty description="暂无消费记录" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { Empty, Icon } from 'vant';
import apiUtil from "@/global/apiUtil";
import vMerchantSelector from "@/components/user/MerchantSelector.vue";
import vDateRangeSelector from "@/components/user/DateRangeSelector.vue";
import vAccountStatement from "@/components/user/AccountStatement.vue";
import util from "@/global/util";
import jsUtil from "@/global/jsUtil";
import apiUser from "@/api/user";
import { useRouter } from 'vue-router';

const props = defineProps({
  playerScore: Object,
  playerIndex: Number
});
const emit = defineEmits(['name-click']);
const router = useRouter();

const userId = ref('');
const merchants = ref([]);
const selectedMerchant = ref('');

const selectedCategory = ref('所有');
const allCategories = ref(['所有']);
const showFilterPopup = ref(false);
const fromDate = ref(new Date());
const toDate = ref(new Date());
const statements = ref([]);
const showName = ref(false);

const showAccount = computed(() => (category) => {
  if (selectedCategory.value === "所有") {
    return true;
  }
  return selectedCategory.value === category;
});

onMounted(async () => {
  const fd = new Date();
  fd.setDate(fd.getDate() - 7);
  fromDate.value = fd;

  const td = new Date();
  toDate.value = td;

  userId.value = localStorage.getItem("userId");
  await getAccountStatements();
});

const onMerchantSelected = (value) => {
  selectedMerchant.value = value;
};

const selectCategory = (category) => {
  selectedCategory.value = category;
};

const getFilterSummary = () => {
  const merchant = selectedMerchant.value.name || '全部场馆';
  const from = util.formatDate(fromDate.value);
  const to = util.formatDate(toDate.value);
  return `${merchant} | ${from} 至 ${to}`;
};

const onDateRangeChanged = (f, t) => {
  fromDate.value = f.value;
  toDate.value = t.value;
};

const handleFilterConfirm = async () => {
  showFilterPopup.value = false;
  await getAccountStatements();
};

const getAccountStatements = async () => {
  const queryObj = {
    From: util.formatDate(fromDate.value),
    To: util.formatDate(toDate.value),
    merchantId: selectedMerchant.value.id,
  };

  const result = await apiUser.MyAccountStatement(queryObj);
  console.debug(JSON.stringify(result));

  // 创建一个Set来存储唯一的类别
  const categoriesSet = new Set(['所有']);
  const tempStatements = [];

  for (let index = 0; index < result.length; index++) {
    const sr = result[index];
    tempStatements[index] = {
      amount: sr.amount,
      time: sr.cosumeTime,
      payCategory: sr.payCategory,
      payCategoryStr: sr.payCategoryStr,
      unit: sr.unit,
      category: "消费",
      cardConsumeContent: sr.cardConsumeContent,
      internetConsumeContent: sr.internetConsumeContent
    };

    if (sr.consumeCategory == 1) {
      tempStatements[index].category = "充值";
    }

    // 添加类别到Set中，自动去重
    categoriesSet.add(tempStatements[index].category);
  }

  statements.value = tempStatements;
  allCategories.value = Array.from(categoriesSet);
};

const onClickRoundScore = (r, i, pi) => {
  emit('name-click', pi);
};

const backToPreviousPage = () => {
  router.back();
};
</script>

<style>
/* 仅保留特定样式，复用通用样式 */
.container {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.fixed-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.filter-section {
  padding: 8px;
  background-color: white;
  border-radius: 0 0 0.427rem 0.427rem;
}

.filter-button {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filter-popup {
  height: 60vh;
  padding: 16px;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-title {
  font-size: 16px;
  font-weight: 500;
}

.selector-component {
  margin-bottom: 0.32rem;
  background-color: #f5f7fa;
  border-radius: 0.213rem;
  padding: 0.213rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.selector-row {
  margin-bottom: 0.16rem;
}

.merchant-selector,
.date-selector {
  width: 100%;
}

.category-tags {
  padding: 0.32rem;
  background: white;
  border-radius: 0.427rem;
  margin-bottom: 0.32rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.category-tag {
  padding: 0.16rem 0.32rem;
  background-color: #f5f7fa;
  border-radius: 1rem;
  font-size: 0.347rem;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #ebedf0;
  user-select: none;
}

.category-tag:hover {
  background-color: #e8f2fe;
  border-color: #3498db;
  color: #3498db;
}

.category-tag-active {
  background-color: #3498db;
  color: white;
  border-color: #3498db;
}

.category-tag-active:hover {
  background-color: #2980b9;
  color: white;
}

.scrollable-content {
  height: calc(100vh - 150px);
  padding: 0.32rem;
}

.statement-list {
  padding: 0.16rem 0;
}

@media (max-width: 320px) {
  .category-tags {
    padding: 0.213rem;
  }

  .category-tag {
    margin-bottom: 0.107rem;
  }
}
</style>